import { Injectable } from '@angular/core';
import {HttpService} from '../http.service';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TicketnotesService {

  private ticketNotesPath = 'ticketnotes';
  private notesPath = 'ticket';
  private notesTabPath = 'notes';

  constructor(private httpService: HttpService, private router: Router) {
  }

  getNotes(ticketID, page): Observable<any> {
    return this.httpService.httpGet(this.ticketNotesPath + '/' + ticketID + '?page=' + page).pipe(response => {
      return response;
    });
  }

  addNote(body): Observable<any> {
    return this.httpService.httpPost(this.ticketNotesPath, body).pipe(response => {
      return response;
    });
  }

  closeTicket(ticketID, jobID){
    this.router.navigate([this.notesPath, ticketID, this.notesTabPath, jobID]);
  }
}
